import {fingerprint} from './fingerprint.js';

/**
 * @param config
 */
window.leadsFp = (config = {}) => {
    const debug = window.location.search.indexOf('fpdebug') !== -1;
    if (debug) {
        config.encrypt = false;
        config.profile = true;
        config.showErrors = true;
    }
    /**
     * Инжектим объект window, в модуле он бывает недоступен
     * @var {IFingerprintParams}
     */
    const defaultConfig = {
        encrypt: true,
        enhanceLinks: true,
        profile: false,
        showErrors: false,
        window: window,
        storeLfidData: false,
    };
    fingerprint({
        ...defaultConfig,
        ...config,
    });
};
